// @flow
/* eslint-disable ta-code-conventions/has-matching-storydoc */
/* eslint-disable ta-code-conventions/has-matching-test */
import * as React from 'react';

import classnames from '@ta/common.classnames';
import { type Source as ResponsiveImageSource } from '@ta/media.image';
import { ProtectedObfuscatedLink } from '@ta/social.obfuscation';
import LinkPreviewContent from './LinkPreviewContent';
import LinkPreviewImage from './LinkPreviewImage';
import styles from './LinkPreview.less';

/**
 * This is the state for each link preview item
 */
export type LinkPreviewState = {
  // eslint-disable-next-line ta-code-conventions/require-jsdoc
  id: number,
  // eslint-disable-next-line ta-code-conventions/require-jsdoc
  title: string,
  // eslint-disable-next-line ta-code-conventions/require-jsdoc
  description: string,
  // eslint-disable-next-line ta-code-conventions/require-jsdoc
  url: string,
  // eslint-disable-next-line ta-code-conventions/require-jsdoc
  urlDomain: string,
  // eslint-disable-next-line ta-code-conventions/require-jsdoc
  mediaKeyId?: number,
  // eslint-disable-next-line ta-code-conventions/require-jsdoc
  imgSource?: Array<ResponsiveImageSource>,
};

// eslint-disable-next-line ta-code-conventions/require-jsdoc
export type LinkPreviewPadding = 'none' | 'tighten' | 'tighten_bottom';

type Props = {
  linkPreviewState: LinkPreviewState,
  isClickable?: boolean,
  onClick?: (SyntheticMouseEvent<HTMLElement>) => mixed,

  /** Forces a border to the entirety of the preview on all viewport categories  */
  border?: boolean,

  /** On MW, adds delineation between the image and the content */
  delineateContent?: boolean,

  /** Tightens the spacing surrounding the content */
  tightenContent?: LinkPreviewPadding,

  /** Smaller version of LinkPreview */
  matchingShelfItem?: boolean,
};

/**
 * Renders a preview container that displays the URL props such as title/description/image if available
 */
const LinkPreview = ({
  linkPreviewState: preview,
  onClick,
  isClickable,
  border,
  delineateContent,
  tightenContent,
  matchingShelfItem,
}: Props) => {
  const element = (
    <div
      className={classnames(
        styles.previewWrapper,
        { [styles.previewUploaderBorder]: !isClickable },
        { [styles.border]: border },
      )}
    >
      {preview.imgSource && (
        <LinkPreviewImage matchingShelfItem={matchingShelfItem} sources={preview.imgSource} />
      )}
      <LinkPreviewContent
        isClickable={isClickable}
        linkPreviewState={preview}
        onClick={onClick}
        className={classnames(styles.contentWrapper, {
          [styles.contentDelineation]: delineateContent,
          [styles.tightenContentTags]: tightenContent === 'tighten_bottom',
          [styles.tightenContentNoTags]: tightenContent === 'tighten',
          [styles.matchingShelfItem]: matchingShelfItem,
        })}
        matchingShelfItem={matchingShelfItem}
      />
    </div>
  );

  return isClickable ? (
    <ProtectedObfuscatedLink
      className=""
      target="_blank"
      onClick={onClick}
      encodedUrl={preview.url}
    >
      {element}
    </ProtectedObfuscatedLink>
  ) : (
    element
  );
};

LinkPreview.defaultProps = {
  isClickable: false,
  onClick: undefined,
  border: true,
  delineateContent: false,
  tightenContent: 'none',
};

export default LinkPreview;
